import { Link } from 'react-router-dom';
import { articles, hotArticles } from '@/mocks/articles';

export default function ArticleRecommend() {
  const selectedArticles = hotArticles
    .map((id) => articles.find((a) => a.id === id)!)
    .filter(Boolean);

  return (
    <section className="py-12 md:py-16">
      <div className="px-4 md:px-6 lg:px-10">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-6 md:mb-8">
            <div>
              <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground-50">
                精选影评
              </h3>
              <p className="text-sm text-foreground-500 mt-1">深度解读，挖掘电影背后的故事</p>
            </div>
            <Link
              to="/category/all"
              className="flex items-center gap-1.5 text-sm text-primary-400 hover:text-primary-300 transition-colors whitespace-nowrap cursor-pointer"
            >
              更多文章
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
            {selectedArticles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group cursor-pointer"
              >
                <article className="rounded-xl overflow-hidden bg-background-100/60 border border-background-300/20 hover:border-primary-500/30 transition-all duration-300 h-full">
                  <div className="relative aspect-[16/9] overflow-hidden">
                    <img
                      src={article.coverUrl}
                      alt={article.title}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                      loading="lazy"
                    />
                    <div className="absolute top-3 left-3">
                      <span className="px-3 py-1 text-xs font-medium rounded-full bg-primary-500/80 text-background-950 whitespace-nowrap">
                        {article.category}
                      </span>
                    </div>
                  </div>
                  <div className="p-4 md:p-5">
                    <h4 className="text-base md:text-lg font-heading font-semibold text-foreground-100 group-hover:text-primary-400 transition-colors line-clamp-2 mb-2">
                      {article.title}
                    </h4>
                    <p className="text-sm text-foreground-500 line-clamp-2 mb-3 leading-relaxed">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center justify-between text-xs text-foreground-600">
                      <span>{article.author}</span>
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line"></i>
                        {article.readCount.toLocaleString()}
                      </span>
                    </div>
                  </div>
                </article>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}